export const quantumPagePL = {
  "seo": {
    "title": "Suwerenne LLM i Kwantowe AI | pAIoneer Labs GmbH",
    "description": "Nasz cel z Niemiec: pod nadzorem Veridion („AI rozwija AI dalej”) stworzyć własne kompaktowe modele językowe i Kwantowe Transformery, które w przyszłości będą konkurować z wielkimi modelami z USA i Chin."
  },
  "hero": {
    "kicker": "Made in Germany · AI rozwija AI",
    "title": "Suwerenne LLM i Kwantowe AI",
    "claim": "Nasz cel z Niemiec: opracować własne modele językowe i Kwantowe Transformery, które w przyszłości nawiążą walkę z wielkimi modelami z USA i Chin.",
    "subtitle": "W realnych projektach wdrożeniowych dotychczasowe podejścia europejskie — niemieckie modele od Aleph Alpha (takie jak Kolibri), francuskie modele wokół Mistral, EuroLLM oraz zwłaszcza szwajcarski model Apertus — zostały przetestowane na prawdziwych problemach firm. Żaden z nich nie spełnia wymagań przedsiębiorstw. Dlatego nasza AI pod nadzorem [Veridion](veridion) („AI rozwija AI dalej”) wykonuje kolejny krok: bada i projektuje drogę do kompaktowych modeli językowych Made in Germany, które będą znacznie wydajniejsze niż modele francuskie, a jako drugi filar rozwija własne Kwantowe Transformery.",
    "cta": "Umów rozmowę"
  },
  "pillars": {
    "title": "Nad czym pracuje nasza AI",
    "subtitle": "Dwa obszary badawcze, w których nasi cyfrowi pracownicy projektują nowe architektury, sprawdzają je w symulatorze i budują krok po kroku.",
    "items": [
      {
        "title": "Czego wymaga się od modelu w codziennej pracy",
        "description": "W zastosowaniach produkcyjnych liczy się wieloetapowe wnioskowanie logiczne, niezawodne użycie narzędzi w długich łańcuchach zadań, czyste tworzenie oprogramowania i bezbłędne procesy biurowe. Według tego oceniamy każdą architekturę od samego początku."
      },
      {
        "title": "Kompaktowe modele dla własnej infrastruktury",
        "description": "Zamiast coraz większych centrów danych naszym celem będzie skupienie dużej głębi rozumowania w kompaktowym modelu, który firmy będą mogły uruchamiać lokalnie na własnym sprzęcie."
      },
      {
        "title": "Kwantowe Transformery i Kwantowe AI",
        "description": "W drugim obszarze badamy, jak połączyć architektury transformerowe z parametryzowanymi obwodami kwantowymi i sieciami tensorowymi, aby otworzyć nowe klasy modeli."
      },
      {
        "title": "Własne Quantum IDE i procesory kwantowe",
        "description": "W naszym autorskim środowisku Quantum IDE pracownicy AI projektują, symulują i testują nowe obwody kwantowe względem klasycznych punktów odniesienia przed uruchomieniem na rzeczywistym sprzęcie kwantowym."
      }
    ]
  },
  "gate": {
    "title": "Od stanu badań do planu budowy",
    "subtitle": "Każdy krok rozwojowy opiera się na zweryfikowanej literaturze, pamięci firmy i mierzalnych porównaniach.",
    "stages": [
      {
        "step": "Krok 01",
        "title": "Analiza literatury i pamięć firmy",
        "description": "Nasi pracownicy AI na bieżąco analizują najnowsze prace naukowe dotyczące architektur językowych i kwantowych, zapisując zweryfikowane wnioski w grafie wiedzy przedsiębiorstwa."
      },
      {
        "step": "Krok 02",
        "title": "Plan treningu i symulacja obwodów",
        "description": "Wspólnie z Rozwojem Produktu powstaje szczegółowa mapa drogowa treningu naszego przyszłego modelu językowego, podczas gdy w Quantum IDE testowane są równolegle nowe obwody kwantowe."
      },
      {
        "step": "Krok 03",
        "title": "Weryfikacja naukowa w procesie IDD",
        "description": "Fizycy i badacze AI sprawdzają każdą hipotezę, pomiar i projekt poprzez [Intent-Driven Development](idd) (IDD) jako human-in-the-loop i zatwierdzają kolejny krok."
      }
    ]
  },
  "stack": {
    "title": "Człowiek i AI w jednej jednostce badawczej",
    "subtitle": "Badania, rozwój produktu i nadzór naukowy zazębiają się w stałych cyklach.",
    "items": [
      {
        "title": "Cyfrowi badacze przez całą dobę",
        "description": "Wyspecjalizowani pracownicy AI prowadzą kwerendę literatury, wyprowadzenia matematyczne, projektowanie obwodów i ewaluację przez całą dobę."
      },
      {
        "title": "Fizycy w pętli Human-in-the-Loop",
        "description": "Ludzcy naukowcy wyznaczają kierunek badań, weryfikują założenia oraz decydują o zatwierdzeniach, uruchomieniach sprzętowych i publikacjach."
      },
      {
        "title": "Spójność z Rozwojem Produktu",
        "description": "W ścisłej współpracy z zespołem produktowym potwierdzone wyniki badań trafiają bezpośrednio do naszych narzędzi i przyszłych rozwiązań dla firm."
      },
      {
        "title": "Śledzenie aż do źródła",
        "description": "Każda decyzja architektoniczna, odrzucony wariant i wynik pomiaru pozostają trwale udokumentowane i możliwe do sprawdzenia w dowolnym momencie."
      }
    ]
  },
  "cta": {
    "title": "Rozmowa o badaniach",
    "subtitle": "Chcesz porozmawiać o naszych badaniach nad suwerennymi modelami językowymi i Kwantowymi Transformerami? Napisz do nas.",
    "button": "Napisz wiadomość"
  }
};
